module.exports = __webpack_public_path__ + "videos/launch-cn.b8237c9.mp4";